/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Image, Text, Pressable, Icon } from '@components/atoms'
import { Footer } from '@components/systems'
import page1_img1 from '@public/images/pages/home/1.png'
import page1_img2 from '@public/images/pages/home/2.png'
import page1_img3 from '@public/images/pages/home/3.png'
import page1_img4 from '@public/images/pages/home/4.png'
import contactImg1 from '@public/images/pages/home/5.png'
import contactImg2 from '@public/images/pages/home/6.png'

import bannerImg from '@public/images/pages/home/banner.png'
import arrowImg from '@public/images/pages/home/arrow.png'
import lineImg1 from '@public/images/pages/home/line1.png'
import lineImg2 from '@public/images/pages/home/line2.png'

import { useNavigate } from 'react-router-dom'
import { grey, lime } from '@mui/material/colors'

const HomePage = () => {
	// hook
	const navigate = useNavigate()

	const secondRef = React.useRef<HTMLDivElement>(null)
	const [reveal, setReveal] = React.useState(0)
	const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 720)

	const REVEAL_START_OFFSET = 595
	const REVEAL_DISTANCE = 300

	React.useEffect(() => {
		const onResize = () => {
			setIsMobile(window.innerWidth <= 720)
		}

		window.addEventListener('resize', onResize)
		return () => window.removeEventListener('resize', onResize)
	}, [])

	React.useEffect(() => {
		if (isMobile) {
			setReveal(1)
			return
		}

		const onScroll = () => {
			if (!secondRef.current) return

			const rect = secondRef.current.getBoundingClientRect()
			const adjustedTop = rect.top - REVEAL_START_OFFSET
			const progress = Math.min(Math.max(-adjustedTop / REVEAL_DISTANCE, 0), 1)

			setReveal(progress)
		}

		onScroll()
		window.addEventListener('scroll', onScroll, { passive: true })
		return () => window.removeEventListener('scroll', onScroll)
	}, [isMobile])

	return (
		<View css={style}>
			<View className="mainView">
				<View className="mainBgView">
					<Image src={page1_img1} className="page1Img page1Img1" />
					<Image src={page1_img2} className="page1Img page1Img2" />
					<Image src={page1_img3} className="page1Img page1Img3" />
					<Image src={page1_img4} className="page1Img page1Img4" />
				</View>

				<View className="mainContentsOuterView" id="home">
					<View className="mainContentsView">
						<Text className="mainTitle title1">주다스</Text>
						<Text className="mainTitle title2">프로젝트</Text>
						<Image src={bannerImg} className="bannerImage" />
					</View>

					<View
						className="mainSecondContentsView"
						ref={secondRef}
						style={{
							opacity: reveal,
							filter: `blur(${(1 - reveal) * 10}px)`,
							transform: `translateY(${(1 - reveal) * 30}px)`,
						}}
					>
						<View className="mainSecondTextView large">
							<Text className="mainSecondTitle">
								주다스 프로젝트는 사람들이 기억하는 순간을 만듭니다.
							</Text>

							<Text className="mainSecondText">
								주다스 프로젝트는 사람을 중심에 두고 진짜 이야기를 만드는
							</Text>
							<Text className="mainSecondText">크리에이티브 이벤트 스튜디오입니다.</Text>
							<Text className="mainSecondText">
								우리는 보여주기 위한 행사가 아닌, 사람에게 닿는 순간을 만듭니다.
							</Text>
							<Text className="mainSecondText">
								아이디어에서 현장까지, 기획부터 연출·운영까지 전 과정을 직접 설계하며
							</Text>
							<Text className="mainSecondText">
								각 프로젝트에 진심과 책임을 담아 완성합니다.
							</Text>
						</View>

						<View className="mainSecondTextView small">
							<Text className="mainSecondTitle">주다스 프로젝트는 사람들이</Text>
							<Text className="mainSecondTitle">기억하는 순간을 만듭니다.</Text>

							<View className="mainSecondTextView">
								<Text className="mainSecondText">
									주다스 프로젝트는 사람을 중심에 두고 진짜 이야기를 만드는 크리에이티브
									이벤트 스튜디오입니다. 우리는 보여주기 위한 행사가 아닌, 사람에게 닿는
									순간을 만듭니다. 아이디어에서 현장까지, 기획부터 연출·운영까지 전 과정을
									직접 설계하며 각 프로젝트에 진심과 책임을 담아 완성합니다.
								</Text>
							</View>
						</View>

						<View className="mainSecondBoxView">
							<View className="boxView">
								<Text className="boxTitle">CREATIVITY</Text>
								<View className="boxTextView">
									<Text className="boxText">우리는 문제를</Text>
									<Text className="boxText">새롭게 바라보고,</Text>
									<br></br>
									<Text className="boxText">사람의 기억에 남는</Text>
									<Text className="boxText">경험을 설계합니다.</Text>
								</View>
							</View>
							<View className="boxView">
								<Text className="boxTitle">AUTHENTICITY</Text>

								<View className="boxTextView">
									<Text className="boxText">말보다 행동으로,</Text>
									<Text className="boxText">포장보다 본질로</Text>
									<br></br>
									<Text className="boxText">모든 프로젝트에</Text>
									<Text className="boxText">정직한 태도와</Text>
									<Text className="boxText">책임감을 담습니다.</Text>
								</View>
							</View>

							<View className="boxView">
								<Text className="boxTitle">HUMANITY</Text>
								<View className="boxTextView">
									<Text className="boxText">우리는 행사의 중심에</Text>
									<Text className="boxText">{"항상 '사람'을 둡니다."}</Text>
									<br></br>
									<Text className="boxText">참여자, 클라이언트, 스태프</Text>
									<Text className="boxText">관계 속에서 진짜 의미를</Text>
									<Text className="boxText">만들어갑니다.</Text>
								</View>
							</View>
						</View>
					</View>
				</View>
			</View>

			<View className="projectView" id="project">
				<View className="projectTitleView">
					<Text className="projectTitle">PROJECTS</Text>
					<Image src={bannerImg} className="bannerImage" />
					<Image src={arrowImg} className="arrowImage" />
				</View>

				<View className="projectContentsView">
					<View className="projectBoxView">
						<View className="projectBoxNumberView">
							<Image src={lineImg2} className="lineImage2" />
							<Text className="projectNumber">1</Text>
						</View>
						<View className="projectBoxTitleView">
							<Text className="projectTitle">기업/브랜드 행사</Text>
						</View>
						<View className="projectBoxTextOuterView">
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">제품 론칭 쇼케이스</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">팝업스토어 오프닝 파티</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">브랜드 네트워킹 파티</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">미니 전시 / 체험형 이벤트</Text>
							</View>
						</View>
					</View>

					<View className="projectBoxView">
						<View className="projectBoxNumberView">
							<Image src={lineImg2} className="lineImage2" />
							<Text className="projectNumber">2</Text>
						</View>
						<View className="projectBoxTitleView">
							<Text className="projectTitle">문화/예술/음악 행사</Text>
						</View>
						<View className="projectBoxTextOuterView">
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">인디 공연 / 쇼케이스</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">DJ / 악기 브랜드 행사</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">갤러리 오프닝 / 아트토크</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">크리에이터 모임 / 밋업</Text>
							</View>
						</View>
					</View>

					<View className="projectBoxView">
						<View className="projectBoxNumberView">
							<Image src={lineImg2} className="lineImage2" />
							<Text className="projectNumber">3</Text>
						</View>
						<View className="projectBoxTitleView">
							<Text className="projectTitle">교육/워크숍 행사</Text>
						</View>
						<View className="projectBoxTextOuterView">
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">메이커 워크숍</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">음악·사운드·장비 클래스</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">창업·콘텐츠·브랜딩 특강</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">청년·지역 프로그램</Text>
							</View>
						</View>
					</View>

					<View className="projectBoxView">
						<View className="projectBoxNumberView">
							<Image src={lineImg2} className="lineImage2" />
							<Text className="projectNumber">4</Text>
						</View>
						<View className="projectBoxTitleView">
							<Text className="projectTitle">지역/관공서 행사</Text>
						</View>
						<View className="projectBoxTextOuterView">
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">청년창업 행사</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">문화의 날 / 마을축제</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">버스킹 행사</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">지역상권 활성화 이벤트</Text>
							</View>
							<View className="projectBoxTextView">
								<Icon name="check-bold" />
								<Text className="boxText">출범식 / 시상식 / 관할 행사</Text>
							</View>
						</View>
					</View>
				</View>
			</View>

			<View className="contactView" id="contact">
				<View className="contactTitleView">
					<Text className="contactTitle">CONTACT</Text>
					<Image src={lineImg1} className="contactTitleCircle" />
				</View>

				<View className="contactContentView">
					<View className="contactContentInnerView">
						<View className="contactLableView">
							<Text className="contactLable">Tel</Text>
							<Text className="contactLable">E-mail</Text>
						</View>

						<View className="contactTextView">
							<Text className="contactText">051-791-1206</Text>
							<Text className="contactText">boram@judahs.io</Text>
						</View>
					</View>
				</View>

				<View className="contactBgView">
					<Image src={contactImg1} className="contactImage img1" />
					<Image src={contactImg2} className="contactImage img2" />
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default HomePage

const style = css({
	position: 'relative',
	width: '100%',

	backgroundImage: 'radial-gradient(#c1c1c1 1px, transparent 1px)',
	backgroundSize: '30px 30px',
	backgroundColor: '#ffffff',

	'.mainView': {
		position: 'relative',
		width: '100%',
		minHeight: 'calc(150vh - 5rem)',

		'.mainBgView': {
			position: 'sticky',
			zIndex: 0,
			width: '100%',
			height: '100vh',
			top: '5rem',
			overflow: 'hidden',
			pointerEvents: 'none',

			'.page1Img': {
				position: 'absolute',
				width: '40rem',
				height: 'auto',
				margin: 'auto',

				'&.page1Img1': {
					top: '0',
					left: 0,
					marginLeft: '-10rem',
				},
				'&.page1Img2': {
					bottom: '0rem',
					left: '0',
					marginLeft: '-10rem',
				},
				'&.page1Img3': {
					top: '0rem',
					right: '0rem',
					marginRight: '-10rem',
				},
				'&.page1Img4': {
					bottom: '0rem',
					right: '0rem',
					marginRight: '-10rem',
				},
			},
		},

		'.mainContentsOuterView': {
			'.mainContentsView': {
				position: 'absolute',
				width: '50rem',
				height: '15rem',
				margin: 'auto',
				top: 'calc(50vh - 10rem)',
				left: 0,
				right: 0,

				'.mainTitle': {
					position: 'absolute',
					zIndex: 2,
					margin: 0,
					fontFamily: 'sangSangAnt',
					fontSize: '130px',
					fontWeight: '300',

					'&.title1': {
						top: 0,
					},
					'&.title2': {
						bottom: 0,
					},
				},

				'.bannerImage': {
					position: 'absolute',
					zIndex: 1,
					width: '50rem',
					height: 'auto',
					margin: 'auto',
					top: 0,
					bottom: 0,
					left: 0,
					right: 0,
				},
			},

			'.mainSecondContentsView': {
				position: 'relative',
				minHeight: '100vh',
				zIndex: 2,
				marginTop: '-50vh',
				paddingTop: '10rem',

				'.mainSecondTextView': {
					marginBottom: '4rem',

					'&.small': {
						display: 'none',
					},

					'.mainSecondTitle': {
						marginBottom: '4rem',
						fontFamily: 'NanumGothicExtraBold',
						fontSize: '24px',
					},
					'.mainSecondText': {
						fontFamily: 'NanumGothicRegular',
						fontSize: '20px',
					},
				},

				'.mainSecondBoxView': {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					marginTop: '2rem',

					'.boxView': {
						width: '12rem',
						height: '12rem',
						background: '#ffe828',

						'&:nth-child(2)': {
							margin: '0 5rem',
						},

						'.boxTitle': {
							margin: '1rem 0',
							fontFamily: 'sourGummy',
							fontSize: '26px',
						},
						'.boxTextView': {
							padding: '0 0.5rem',
							'.boxText': {
								margin: '0 0 0.3rem',
								fontFamily: 'NanumGothicRegular',
							},
						},
					},
				},
			},
		},
	},

	'.projectView': {
		width: '100%',
		height: '100vh',
		paddingTop: '2rem',

		'.projectTitleView': {
			position: 'relative',
			width: '100%',
			height: '20rem',

			'.projectTitle': {
				position: 'absolute',
				zIndex: 2,
				height: '130px',
				margin: 'auto',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				fontFamily: 'sangSangAnt',
				fontSize: '130px',
				fontWeight: '300',
			},
			'.bannerImage': {
				position: 'absolute',
				zIndex: 1,
				width: '50rem',
				height: 'auto',
				margin: 'auto',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
			},
			'.arrowImage': {
				position: 'absolute',
				width: '13rem',
				margin: 'auto',
				top: '-12rem',
				bottom: 0,
				right: '-60rem',
				left: 0,
			},
		},

		'.projectContentsView': {
			display: 'flex',
			justifyContent: 'center',
			flexWrap: 'wrap',

			'.projectBoxView': {
				width: '20rem',

				'.projectBoxNumberView': {
					position: 'relative',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: '100%',
					height: '8rem',

					'.lineImage2': {
						position: 'absolute',
						width: '5rem',
					},
					'.projectNumber': {
						fontSize: '20px',
					},
				},

				'.projectBoxTitleView': {
					width: '15rem',
					margin: 'auto',
					marginBottom: '1rem',
					borderBottom: '3px dotted',

					'.projectTitle': {
						fontSize: '22px',
					},
				},

				'.projectBoxTextOuterView': {
					width: '15rem',
					margin: 'auto',

					'.projectBoxTextView': {
						display: 'flex',
						alignItems: 'center',
						'.boxText': {
							margin: '0.5rem 0 0.5rem 0.5rem',
							fontSize: '18px',
							textAlign: 'left',
							wordBreak: 'keep-all',
						},
					},
				},
			},
		},
	},

	'.contactView': {
		position: 'relative',
		width: '100%',
		minHeight: 'calc(100vh - 5rem)',

		'.contactBgView': {
			position: 'absolute',
			width: '100%',
			minHeight: '100%',
			top: 0,

			'.contactImage': {
				position: 'absolute',
				width: 'auto',
				height: '80vh',
				top: '2rem',

				'&.img1': {
					left: '10rem',
				},
				'&.img2': {
					right: '10rem',
				},
			},
		},

		'.contactTitleView': {
			position: 'relative',
			width: '100%',
			height: '20rem',

			'.contactTitle': {
				position: 'absolute',
				zIndex: 2,
				height: '130px',
				margin: 'auto',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				fontFamily: 'sangSangAnt',
				fontSize: '130px',
				fontWeight: '300',
			},
			'.contactTitleCircle': {
				position: 'absolute',
				zIndex: 1,
				width: '40rem',
				height: 'auto',
				margin: 'auto',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
			},
		},

		'.contactContentView': {
			width: '100%',
			minHeight: '20rem',
			marginTop: '3rem',

			'.contactContentInnerView': {
				position: 'absolute',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '23rem',
				height: 'fit-content',
				margin: 'auto',
				right: 0,
				left: 0,
				background: '#FFF',
				borderRadius: '5px',
				overflow: 'hidden',
				boxShadow: '1px 1px 10px 1px #E0E0E0',

				'.contactLableView': {
					width: '8rem',
					padding: '0.5rem 1rem',
					borderRight: '3px solid #ffe828',

					'.contactLable': {
						textAlign: 'left',
					},
				},
				'.contactTextView': {
					width: '15rem',
					padding: '0.5rem 1rem',
					'.contactText': {
						textAlign: 'left',
					},
				},
			},
		},
	},

	'@media (max-width: 1380px)': {
		'.mainView': {
			'.mainBgView': {
				'.page1Img': {
					width: '35rem',
				},
			},

			'.mainContentsOuterView': {
				'.mainContentsView': {
					height: '13rem',

					'.mainTitle': {
						fontSize: '110px',
					},
					'.bannerImage': {
						width: '40rem',
					},
				},

				'.mainSecondContentsView': {
					'.mainSecondBoxView': {
						'.boxView': {
							'&:nth-child(2)': {
								margin: '0 3rem',
							},
						},
					},
				},
			},
		},

		'.projectView': {
			'.projectTitleView': {
				'.projectTitle': {
					fontSize: '110px',
				},
				'.bannerImage': {
					width: '40rem',
				},
				'.arrowImage': {
					width: '10rem',
					right: '-50rem',
				},
			},

			'.projectContentsView': {
				'.projectBoxView': {
					width: '16rem',

					'.projectBoxTitleView': {
						width: '14rem',
					},
					'.projectBoxTextOuterView': {
						width: '14rem',
					},
				},
			},
		},

		'.contactView': {
			'.contactBgView': {
				'.contactImage': {
					'&.img1': {
						left: '5rem',
					},
					'&.img2': {
						right: '5rem',
					},
				},
			},

			'.contactTitleView': {
				'.contactTitle': {
					fontSize: '110px',
				},
				'.contactTitleCircle': {
					width: '35rem',
				},
			},
		},
	},

	'@media (max-width: 1330px)': {
		'.mainView': {
			'.mainBgView': {
				'.page1Img': {
					width: '30rem',

					'&.page1Img1': {
						top: '1rem',
					},
					'&.page1Img2': {
						bottom: '2rem',
					},
					'&.page1Img3': {
						top: '1rem',
					},
					'&.page1Img4': {
						bottom: '2rem',
					},
				},
			},
		},
	},

	'@media (max-width: 1080px)': {
		'.mainView': {
			'.mainBgView': {
				'.page1Img': {
					width: '28rem',

					'&.page1Img1': {
						top: '2rem',
						left: 0,
						marginLeft: '-10rem',
					},
					'&.page1Img2': {
						bottom: '3rem',
						left: '0',
						marginLeft: '-10rem',
					},
					'&.page1Img3': {
						top: '2rem',
						right: '0rem',
						marginRight: '-10rem',
					},
					'&.page1Img4': {
						bottom: '3rem',
						right: '0rem',
						marginRight: '-10rem',
					},
				},
			},

			'.mainContentsOuterView': {
				'.mainContentsView': {
					height: '12rem',

					'.mainTitle': {
						fontSize: '100px',
					},
					'.bannerImage': {
						width: '35rem',
					},
				},

				'.mainSecondContentsView': {
					'.mainSecondTextView': {
						'.mainSecondTitle': {
							fontSize: '22px',
						},
						'.mainSecondText': {
							fontSize: '18px',
						},
					},
					'.mainSecondBoxView': {
						'.boxView': {
							'&:nth-child(2)': {
								margin: '0 2rem',
							},
						},
					},
				},
			},
		},

		'.projectView': {
			'.projectTitleView': {
				'.projectTitle': {
					fontSize: '100px',
				},
				'.bannerImage': {
					width: '35rem',
				},
				'.arrowImage': {
					width: '10rem',
					right: '-40rem',
				},
			},

			'.projectContentsView': {
				'.projectBoxView': {
					width: '25%',
					padding: '0 2rem',

					'.projectBoxTitleView': {
						width: '100%',
					},
					'.projectBoxTextOuterView': {
						width: '100%',

						'.projectBoxTextView': {
							'.boxText': {
								fontSize: '15px',
							},
						},
					},
				},
			},
		},

		'.contactView': {
			'.contactBgView': {
				height: '60vh',

				'.contactImage': {
					'&.img1': {
						left: '2rem',
					},
					'&.img2': {
						right: '2rem',
					},
				},
			},

			'.contactTitleView': {
				'.contactTitle': {
					fontSize: '100px',
				},
				'.contactTitleCircle': {
					width: '30rem',
				},
			},
		},
	},

	'@media (max-width: 1000px)': {
		'.mainView': {
			'.mainBgView': {
				'.page1Img': {
					width: '25rem',

					'&.page1Img1': {
						top: '1rem',
					},
					'&.page1Img2': {
						bottom: '2rem',
					},
					'&.page1Img3': {
						top: '1rem',
					},
					'&.page1Img4': {
						bottom: '2rem',
					},
				},
			},
		},

		'.projectView': {
			'.projectTitleView': {
				height: '17rem',
			},
			'.projectContentsView': {
				'.projectBoxView': {
					padding: '0 1rem',

					'.projectBoxNumberView': {
						height: '6rem',
					},

					'.projectBoxTitleView': {
						'.projectTitle': {
							fontSize: '18px',
						},
					},
					'.projectBoxTextOuterView': {
						'.projectBoxTextView': {
							'.boxText': {
								fontSize: '13px',
							},
						},
					},
				},
			},
		},

		'.contactView': {
			minHeight: 'calc(60vh - 5rem)',

			'.contactBgView': {
				'.contactImage': {
					width: '12rem',
					height: 'auto',
				},
			},
		},
	},

	'@media (max-width: 830px)': {
		'.mainView': {
			'.mainBgView': {
				'.page1Img': {
					width: '23rem',

					'&.page1Img1': {
						top: '2rem',
					},
					'&.page1Img2': {
						bottom: '3rem',
					},
					'&.page1Img3': {
						top: '2rem',
					},
					'&.page1Img4': {
						bottom: '3rem',
					},
				},
			},

			'.mainContentsOuterView': {
				'.mainContentsView': {
					width: '100%',
					height: '10rem',

					'.mainTitle': {
						fontSize: '90px',
					},
					'.bannerImage': {
						width: '30rem',
					},
				},

				'.mainSecondContentsView': {
					'.mainSecondTextView': {
						'.mainSecondTitle': {
							fontSize: '18px',
						},
						'.mainSecondText': {
							fontSize: '14px',
						},
					},
					'.mainSecondBoxView': {
						'.boxView': {
							'&:nth-child(2)': {
								margin: '0 3rem',
							},
						},
					},
				},
			},
		},

		'.projectView': {
			height: 'fit-content',

			'.projectTitleView': {
				height: '17rem',

				'.projectTitle': {
					fontSize: '90px',
				},
				'.bannerImage': {
					width: '30rem',
				},
				'.arrowImage': {
					width: '10rem',
					right: '-35rem',
				},
			},
			'.projectContentsView': {
				'.projectBoxView': {
					width: '50%',
					padding: '0 1rem',

					'.projectBoxNumberView': {
						height: '6rem',
					},

					'.projectBoxTitleView': {
						'.projectTitle': {
							fontSize: '18px',
						},
					},
					'.projectBoxTextOuterView': {
						'.projectBoxTextView': {
							'.boxText': {
								fontSize: '13px',
							},
						},
					},
				},
			},
		},

		'.contactView': {
			minHeight: 'fit-content',
			height: 'fit-content',
			marginBottom: '5rem',
			'.contactBgView': {
				position: 'relative',
				height: '24rem',
				top: '0',

				'.contactImage': {
					position: 'relative',
					width: '8rem',
					height: 'auto',

					'&.img1': {
						marginRight: '4rem',
					},
					'&.img2': {
						marginLeft: '4rem',
					},
				},
			},

			'.contactTitleView': {
				height: '12rem',
				'.contactTitle': {
					fontSize: '90px',
				},
				'.contactTitleCircle': {
					width: '25rem',
					top: '-2rem',
				},
			},

			'.contactContentView': {
				minHeight: 'fit-content',
				height: '6rem',
				marginTop: '0',
			},
		},
	},

	'@media (max-width: 720px)': {
		'.mainView': {
			minHeight: 'calc(120vh - 5rem)',

			'.mainBgView': {
				position: 'relative',
				minHeight: '30rem',
				height: '35rem',
				top: '0',

				'.page1Img': {
					width: '28%',
					margin: '0',

					'&.page1Img1': {
						top: '20rem',
						left: 0,
						marginLeft: '0',
					},
					'&.page1Img2': {
						top: '20rem',
						left: '23%',
						bottom: 'unset',
						marginLeft: '0',
					},
					'&.page1Img3': {
						top: '20rem',
						right: '0',
						marginRight: '0',
					},
					'&.page1Img4': {
						top: '20rem',
						bottom: 'unset',
						right: '23%',
						marginRight: '0',
					},
				},
			},

			'.mainContentsOuterView': {
				marginBottom: '5rem',

				'.mainContentsView': {
					top: 'calc(30vh - 10rem)',
				},
				'.mainSecondContentsView': {
					marginTop: '0',
					paddingTop: '2rem',

					'.mainSecondBoxView': {
						display: 'block',
						padding: '0 1rem',

						'.boxView': {
							width: '100%',
							height: 'fit-content',
							padding: '1rem',

							'&:nth-child(2)': {
								margin: '1rem 0',
							},

							'.boxTextView': {
								padding: '0 0 1rem',
							},
						},
					},
				},
			},
		},
		'.projectView': {
			marginBottom: '5rem',
			'.projectTitleView': {
				'.arrowImage': {
					width: '5rem',
					top: '-13rem',
					right: '0rem',
					transform: 'rotate(-30deg)',
				},
			},
		},

		'.contactView': {
			'.contactBgView': {
				'.contactImage': {
					width: '8rem',
				},
			},
		},
	},

	'@media (max-width: 650px)': {
		'.mainView': {
			'.mainContentsOuterView': {
				'.mainContentsView': {
					'.bannerImage': {
						width: '25rem',
					},
				},
			},
		},

		'.projectView': {
			'.projectTitleView': {
				'.projectTitle': {
					height: '80px',
					fontSize: '80px',
				},
				'.bannerImage': {
					width: '25rem',
				},
			},
		},

		'.contactView': {
			'.contactTitleView': {
				'.contactTitle': {
					height: '80px',
					fontSize: '80px',
				},

				'.contactTitleCircle': {
					width: '25rem',
					top: '0rem',
				},
			},
		},
	},

	'@media (max-width: 430px)': {
		'.mainView': {
			'.mainContentsOuterView': {
				'.mainContentsView': {
					height: '8rem',
					'.mainTitle': {
						fontSize: '70px',
					},
					'.bannerImage': {
						width: '20rem',
					},
				},

				'.mainSecondContentsView': {
					'.mainSecondTextView': {
						'&.large': {
							display: 'none',
						},
						'&.small': {
							display: 'block',
						},

						'.mainSecondTitle': {
							marginBottom: '0.5rem',
						},

						'.mainSecondTextView': {
							padding: '1rem',
							'.mainSecondText': {
								fontFamily: 'NanumGothicRegular',
								fontSize: '14px',
								textAlign: 'left',
								lineHeight: 1.4,
								textIndent: '1.5rem',
							},
						},
					},
				},
			},
		},

		'.projectView': {
			'.projectTitleView': {
				'.projectTitle': {
					fontSize: '70px',
				},
				'.bannerImage': {
					width: '20rem',
				},
			},
		},

		'.contactView': {
			'.contactTitleView': {
				'.contactTitle': {
					height: '70px',
					fontSize: '80px',
				},

				'.contactTitleCircle': {
					width: '20rem',
					top: '0rem',
				},
			},

			'.contactContentView': {
				'.contactContentInnerView': {
					width: '18rem',
				},
			},

			'.contactBgView': {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				'.contactImage': {
					'&.img1': {
						marginRight: '0',
					},
					'&.img2': {
						marginLeft: '0',
					},
				},
			},
		},
	},
})
